import { render, staticRenderFns } from "./ponds.vue?vue&type=template&id=582cec30&scoped=true"
import script from "./ponds.vue?vue&type=script&lang=js"
export * from "./ponds.vue?vue&type=script&lang=js"
import style0 from "./ponds.vue?vue&type=style&index=0&id=582cec30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582cec30",
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QToggle,QSeparator,QBtn,QDialog,QCard,QForm,QInput,QSelect});qInstall(component, 'directives', {ClosePopup});
